

const IABCMPID = 0;

const host = "auth.negosyonow.com";
const protocol = "https";
const suffix = "consent/";

//https://iabeurope.eu/vendor-list-tcf/
const tcfvendorlist = [
	{
		"name": "Google Advertising Products",
		"vendorid": 755,
		"purposeidlist": [1,3,4,7,9,10]
	}
];

const tcfnonvendorlist = [
	{
		"name": "Meta Platforms, Inc. (Facebook)",
		"vendorid": "meta",
		"purposeidlist": [1,3,4,7]
	},
	{
		"name": "Microsoft Corporation",
		"vendorid": "ms",
		"purposeidlist": [1,7]
	}
];

const TABS_ENABLED = {
	cookie_settings: true,
	vendor: false,
	data_request: true,
}

/*
 * Note: 
 * If two or more category is enabled, it will show the corresponding section in the Cookie Settings
 * If no categories or only essential is enabled, it will show only the minimal banner with no option to customize
 */
const CATEGORIES_ENABLED = {
	essential: true,
	storage: true,
	analytics: true,
	ads: true,
}



export default {
	IABCMPID,
	host,
	protocol,
	suffix,
	tcfvendorlist,
	tcfnonvendorlist,
	CATEGORIES_ENABLED,
	TABS_ENABLED,
};

